// Google Analytics 4 utility functions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    GA_MEASUREMENT_ID: string;
  }
}

/**
 * Check if GA4 is properly initialized
 */
export const isGA4Enabled = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    typeof window.gtag === 'function' &&
    !!process.env.REACT_APP_GA4_MEASUREMENT_ID &&
    process.env.REACT_APP_GA4_MEASUREMENT_ID !== '%REACT_APP_GA4_MEASUREMENT_ID%'
  );
};

/**
 * Send a pageview event to GA4
 * @param path - The page path (e.g., '/signup', '/email-sent-success')
 * @param title - Optional page title
 */
export const trackPageView = (path: string, title?: string): void => {
  if (!isGA4Enabled()) {
    console.log('[GA4] Not enabled - would track pageview:', path);
    return;
  }

  try {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href,
    });
    console.log('[GA4] Page view tracked:', path);
  } catch (error) {
    console.error('[GA4] Error tracking pageview:', error);
  }
};

/**
 * Send a custom event to GA4
 * @param eventName - The name of the event
 * @param eventParams - Optional parameters for the event
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>): void => {
  if (!isGA4Enabled()) {
    console.log('[GA4] Not enabled - would track event:', eventName, eventParams);
    return;
  }

  try {
    window.gtag('event', eventName, eventParams);
    console.log('[GA4] Event tracked:', eventName, eventParams);
  } catch (error) {
    console.error('[GA4] Error tracking event:', error);
  }
};

/**
 * Track signup success conversion
 * This can be configured as a key event in GA4
 */
export const trackSignupSuccess = (): void => {
  trackEvent('signup_success', {
    event_category: 'engagement',
    event_label: 'User Registration Complete',
  });
};
